/** How many existing showcases the add-to-showcase menus load at once. */
export const SHOWCASE_MENU_LIMIT = 5;
